<template>
	<nav class="navbar navbar-expand-md" :class="{scrolled: scrollPosition > 0}">
		<div class="container">
			<div class="row">
				<div class="col-12 d-flex justify-content-between align-items-center flex-wrap">
					<a href="/" class="navbar-brand" @click="hideMenu('Logo')">
						<img src="/assets/images/logo.svg" alt="ANGO">
					</a>
					<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
						<span class="navbar-toggler-icon"></span>
					</button>
					<div class="collapse navbar-collapse justify-content-center" id="navbarNavAltMarkup">
						<div class="navbar-nav" v-if="$route.name == 'Home'">
							<router-link to="#services" v-scroll-to="{ el: '#app', duration: 500}"  @click.native="hideMenu('Usługi')" class="nav-item nav-link">Usługi</router-link>
							<router-link to="#about" v-scroll-to="{ el: '#about', duration: 500}" @click.native="hideMenu('O nas')" class="nav-item nav-link">O nas</router-link>
							<router-link to="#references" v-scroll-to="{ el: '#references', duration: 500}" @click.native="hideMenu('Referencje')" class="nav-item nav-link">Referencje</router-link>
							<router-link to="#contact" v-scroll-to="{ el: '#contact', duration: 500}" @click.native="hideMenu('Kontakt')" class="nav-item nav-link">Kontakt</router-link>
							<a href="/news" @click="hideMenu('Aktualności')" class="nav-item nav-link">Aktualności</a>
						</div>
						<div class="navbar-nav" v-else>
							<a href="/" @click="hideMenu('Usługi')" class="nav-item nav-link">Usługi</a>
							<a href="/#about" @click="hideMenu('O nas')" class="nav-item nav-link">O nas</a>
							<a href="/#references" @click="hideMenu('Referencje')" class="nav-item nav-link">Referencje</a>
							<a href="/#contact" @click="hideMenu('Kontakt')" class="nav-item nav-link">Kontakt</a>
							<a href="/news" @click="hideMenu('Aktualności')" class="nav-item nav-link">Aktualności</a>
						</div>
					</div>
					<div class="phone-cta mt-1 mt-md-0 ml-auto mr-auto mr-md-0 ml-md-auto d-block d-md-flex align-items-cetner">
						<img src="/assets/images/phone.svg" alt="" class="d-inline-block mr-2">
						<a href="tel:228121949" @click="phoneTracking('(22) 812-19-49')">(22) 812-19-49</a>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
	export default {
		name: 'Navbar',
		data() {
			return{
				scrollPosition: null
			}
		},
		methods: {
			updateScroll() {
				this.scrollPosition = window.scrollY
			},
			hideMenu(label = '') {
				let menuList = document.getElementById('navbarNavAltMarkup');
				menuList.classList.remove('show');
				let toggler = document.querySelector('.navbar-toggler');
				toggler.setAttribute('aria-expanded', false);
				if(label !== ''){
					this.navTracking(label)
				}
			},
			navTracking(label){
				this.$gtag.event('Klik', {
					'event_category': 'Nawigacja główna',
					'event_label': label,
					'non_interaction': false
				})
			},
			phoneTracking(number) {
				this.$gtag.event('Wybranie numeru', {
					'event_category': 'Zadzwoń do nas',
					'event_label': number,
					'non_interaction': false
				})
			}
		},
		mounted() {
			window.addEventListener('scroll', this.updateScroll);
		}
	}	
</script>
